import { Link, useLocation } from 'react-router-dom';
import logo from '../../../assets/yalla-business-logo.png';

/**
 * Yalla Business brand mark, pinned as a small watermark in the page's
 * top-left corner (see .ceremony-brand — position: fixed, physical `left`
 * by explicit instruction, regardless of the page's dir="rtl") — visible
 * on every page state (loading, success, error, invalid link, coming soon)
 * via CeremonyShell without competing with the guest's name for attention.
 *
 * The source image was cropped tight to the wordmark (the original was a
 * 640×640 square JPG with the mark occupying only the middle band) and
 * sits in a soft white card so its own white background blends in rather
 * than reading as a hard-edged logo dropped onto the purple gradient.
 *
 * It links to "/" (the coming-soon landing). `replace` is used when we're
 * already there, because CeremonyShell renders this on every page —
 * including "/" itself — and react-router's Link pushes a new history
 * entry even for an identical location; without `replace` here, N taps on
 * an already-current page would mean N Back presses to escape.
 */
export default function BrandLogo() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <Link
      to="/"
      className="ceremony-brand"
      replace={isHome}
      aria-current={isHome ? 'page' : undefined}
    >
      <img className="ceremony-brand__logo" src={logo} alt="Yalla Business" />
    </Link>
  );
}
